import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults, palette } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  get transition() {
    return theme.transition.large;
  },
  // transition: '15000s',
  border: "1px solid #e2e5e8",
  get borderRadius() {
    return theme.borderRadius;
  },
  fontSize: "12px",
  bgColor: "#fff",
  get color() {
    return theme.color.text;
  },
  fixLeftShadow: "inset 5px 0px 6px -6px rgb(0 0 0 / 30%)",
  fixRightShadow: "inset -5px 0px 6px -6px rgb(0 0 0 / 30%)",
  // head
  thead: {
    get bgColor() {
      return theme.color.bg;
    },
    get color() {
      return theme.color.lightBlack;
    },
    padding: "0 8px 0 12px",
    fontSize: "12px",
    fontWeight: "bold",
    textAlign: 'left',
    height: "40px",
    delimiterHeight: '12px',
    delimiterColor: '#bfbfbf'
  },
  // tbody 
  tbody: {
    get hoverBgcolor() {
      return theme.color.bg;
    },
    padding: "11px 8px 11px 12px"
  },
  // stripe
  stripeBgColor: '#f9f9fc',
  // group
  group: {
    gap: "8px",
    menuMaxHeight: '200px',
    menuMinWidth: '200px',
    get activeColor() {
      return theme.color.primary;
    },
    headerPadding: "8px",
    get headerBorder() {
      return "1px solid " + theme.color.bg;
    }
  },
  // sort
  sort: {
    iconHeight: "7px",
    gap: "8px",
    // color: `#d0d5d9`,
    get enabledColor() {
      return theme.color.primary;
    }
  },
  expandBgColor: '#fdfcff',
  get selectedBgColor() {
    return palette(theme.color.primary, -4);
  },
  // tree
  arrow: {
    gap: "4px",
    width: "16px"
  },
  resizeWidth: "5px",
  draggingOpacity: ".4"
};
var aligns = ['left', 'right', 'center'];
var table;
setDefault(function () {
  table = deepDefaults(theme, {
    table: defaults
  }).table;
  makeStyles == null || makeStyles.clearCache();
  makeGroupMenuStyles == null || makeGroupMenuStyles.clearCache();
});
export var makeStyles = cache(function makeStyles(k) {
  return /*#__PURE__*/css("font-size:", table.fontSize, ";color:", table.color, ";position:relative;z-index:0;.", k, "-table-wrapper{border-bottom:", table.border, ";overflow:auto;border-radius:", table.borderRadius, ";}table{width:100%;border-spacing:0;table-layout:fixed;}thead{text-align:", table.thead.textAlign, ";font-size:", table.thead.fontSize, ";font-weight:", table.thead.fontWeight, ";position:sticky;top:0;z-index:2;tr{height:", table.thead.height, ";&:not(:last-of-type) th{border-bottom:", table.border, ";}}}th{padding:", table.thead.padding, ";position:relative;background:", table.thead.bgColor, ";line-height:normal;&:before{content:'';height:", table.thead.delimiterHeight, ";position:absolute;background-color:", table.thead.delimiterColor, ";width:1px;left:1px;top:50%;transform:translateY(-50%);}&.", k, "-fixed-right:before{left:-2px;}&:first-of-type:before{display:none;}}.", k, "-table-title{display:inline-flex;align-items:center;max-width:100%;color:", table.thead.color, ";}.", k, "-table-title-text{flex:1;display:inline-flex;line-height:1.4;}tbody{tr{&:hover td{background:", table.tbody.hoverBgcolor, ";}&:last-of-type td{border-bottom-color:transparent;}}}td{padding:", table.tbody.padding, ";border-bottom:", table.border, ";background:", table.bgColor, ";word-wrap:break-word;}.", k, "-fixed-left,.", k, "-fixed-right{position:sticky;z-index:1;&:after{content:'';display:block;transition:box-shadow ", table.transition, ";position:absolute;top:0;bottom:0px;width:10px;pointer-events:none;}}.", k, "-fixed-left:after{right:-11px;}.", k, "-fixed-right:after{left:-11px;}&.", k, "-scroll-left .", k, "-fixed-right:after{box-shadow:", table.fixRightShadow, ";}&.", k, "-scroll-right .", k, "-fixed-left:after{box-shadow:", table.fixLeftShadow, ";}&.", k, "-scroll-middle{.", k, "-fixed-left:after{box-shadow:", table.fixLeftShadow, ";}.", k, "-fixed-right:after{box-shadow:", table.fixRightShadow, ";}}.", k, "-fixed-right+.", k, "-fixed-right:after{display:none;}.", k, "-table-affix-header{position:sticky;top:0;left:0;.", k, "-affix-wrapper{overflow:hidden;}&.", k, "-fixed{position:relative;}}&.", k, "-border,&.", k, "-grid{.", k, "-table-wrapper{border-top:", table.border, ";border-left:", table.border, ";border-right:", table.border, ";}}&.", k, "-grid{td:not(:last-of-type),th:not(:last-of-type){border-right:", table.border, ";}th:before{display:none;}}&.", k, "-stripe{tr:nth-child(even):not(:hover) td{background:", table.stripeBgColor, ";}}.", k, "-table-group{margin-left:", table.group.gap, ";}.", k, "-table-check{.", k, "-checkbox,.", k, "-radio{position:relative;top:-1px;}}.", k, "-column-sortable{cursor:pointer;}.", k, "-column-sort{.", k, "-icon{display:block;height:", _sortInstanceProperty(table).iconHeight, ";line-height:", _sortInstanceProperty(table).iconHeight, ";margin:0 0 1px ", _sortInstanceProperty(table).gap, ";}&.", k, "-desc .", k, "-icon.", k, "-desc,&.", k, "-asc .", k, "-icon.", k, "-asc{color:", _sortInstanceProperty(table).enabledColor, ";}}.", k, "-table-spin.", k, "-overlay{z-index:2;}.", k, "-table-empty{text-align:center;}tr.", k, "-expand{td{padding:0;background:#fdfcff;}}&.", k, "-with-expand{tr:not(.", k, "-expand){td{border-bottom:none;}}}.", k, "-table-expand{border-top:", table.border, ";box-sizing:content-box;}tbody tr.", k, "-selected td{background:", table.selectedBgColor, ";}.", k, "-table-arrow{width:", table.arrow.width, "!important;margin-right:", table.arrow.gap, ";transition:transform ", table.transition, ";position:relative;top:-1px;}tr.", k, "-spreaded{.", k, "-table-arrow{transform:rotate(90deg);}}.", k, "-table-resize{height:100%;width:", table.resizeWidth, ";position:absolute;top:0;left:-1px;cursor:ew-resize;}tr.", k, "-dragging{opacity:", table.draggingOpacity, ";}.", k, "-table-scrollbar{overflow-x:auto;overflow-y:hidden;}.", k, "-table-scrollbar-inner{height:1px;}", _mapInstanceProperty(aligns).call(aligns, function (type) {
    return /*#__PURE__*/css(".", k, "-align-", type, "{text-align:", type, ";}");
  }), ">.", k, "-pagination{margin:16px 0;}&.", k, "-fix-header{min-height:0;.", k, "-table-wrapper{height:100%;}}");
});
export var makeGroupMenuStyles = cache(function makeGroupMenuStyles(k) {
  return /*#__PURE__*/css("min-width:", table.group.menuMinWidth, "!important;.", k, "-dropdown-item.", k, "-active{color:", table.group.activeColor, ";}.", k, "-table-group-header{padding:", table.group.headerPadding, ";border-bottom:", table.group.headerBorder, ";}.", k, "-table-group-body{max-height:", table.group.menuMaxHeight, ";overflow:auto;}.", k, "-table-group-footer{text-align:right;border-top:", table.group.headerBorder, ";padding:8px;.", k, "-btn{margin-left:8px;}}");
});